import styled from 'styled-components';

export const $ScanBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;
  background: rgba(15, 23, 42, 0.55);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const $ScanPanel = styled.div`
  width: min(100%, 420px);
  max-width: 420px;
  margin: auto;
  flex-shrink: 0;
  border-radius: 12px;
  background: ${({ theme }) =>
    theme.systemColors?.defaultBackground ?? theme.colors?.white ?? '#fff'};
  padding: 1rem 1rem 0.85rem;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
`;

export const $ScanTitle = styled.div`
  font-weight: ${({ theme }) => theme.fonts?.weight?.semibold ?? 600};
  font-size: 1rem;
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? '#111827'};
  margin-bottom: 0.5rem;
`;

export const $ScanVideo = styled.video`
  width: 100%;
  max-height: min(52vh, 360px);
  border-radius: 8px;
  background: #0f172a;
  object-fit: cover;
`;

export const $ScanMessage = styled.div<{ $variant?: 'error' | 'info' }>`
  margin-top: 0.5rem;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: ${({ $variant }) => ($variant === 'error' ? '#b91c1c' : '#475569')};
`;

export const $ScanActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.85rem;
`;
